__turbopack_context__.v({
  "card": "Card-module-scss-module__xQCAfG__card",
  "content": "Card-module-scss-module__xQCAfG__content",
  "header": "Card-module-scss-module__xQCAfG__header",
  "image": "Card-module-scss-module__xQCAfG__image",
});
